import {BaseNodeType} from '../../_Base';

export class BaseState {
	constructor(protected node: BaseNodeType) {}
}
